module.exports = {
  microservice1: require('./microservice1'),
  microservice2: require('./microservice2'),
}



// WEBPACK FOOTER //
// /Users/james/code/nextlevel/config/backend/default/index.js